class SearchResults extends HTMLElement {
  constructor() {
    super()
    this.updatedFilterPrice = false
    this.articlesCount =
      this.dataset.articlesCount && parseFloat(this.dataset.articlesCount)
  }

  connectedCallback() {
    if (!this.articlesCount)
      this.articlesCount =
        this.dataset.articlesCount && parseFloat(this.dataset.articlesCount)
    this.tabs = this.querySelectorAll('[data-search-tab]')
    this.filterForm = this.querySelector('#filter-form')

    this.initTabs()

    this.filterForm.addEventListener('change', (e) => {
      this.updateFiltersOptions(e)
    })

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.updateTabs.bind(this, tab))
    })

    this.rangeInput = this.querySelector('[type="range"]')

    this.rangeInput.addEventListener('input', (e) => {
      this.updateRange(e)
    })
  }

  disconnectedCallback() {
    this.tabs = this.querySelectorAll('[data-search-tab]')
    this.filterForm = this.querySelector('#filter-form')

    this.filterForm.removeEventListener('change', (e) => {
      this.updateFiltersOptions(e)
    })

    this.tabs.forEach((tab) => {
      tab.removeEventListener('click', this.updateTabs.bind(this, tab))
    })
  }

  initTabs() {
    const searchParams = new URLSearchParams(window.location.search)
    if (searchParams.get('searchTab') === 'articles') {
      this.dataset.results = 'articles'
    }
  }

  updateTabs(tab) {
    const searchParams = new URLSearchParams(window.location.search)
    if (searchParams.get('searchTab')) {
      searchParams.delete('searchTab')
      const searchParamsString = searchParams.toString()
      window.history.replaceState(
        {},
        '',
        `${window.location.origin}/search?${searchParamsString}`
      )
    }
    this.dataset.results = tab.dataset.searchTab
  }

  updateFiltersOptions(e) {
    this.updateUncheckedInputs()
    if (e.target.tagName === 'INPUT') {
      if (e.target.checked) {
        e.target.closest('li').classList.add('active-input')
      }
    }
    const filterParams = new URLSearchParams(new FormData(e.currentTarget))
    const searchParams = new URLSearchParams(window.location.search).get('q')

    if (e.target.name === 'filter.v.price.lte') {
      this.updatedFilterPrice = true
    }

    if (!this.updatedFilterPrice) filterParams.delete('filter.v.price.lte')
    const searchParamsString = searchParams ? `q=${searchParams}` : ''
    const filterParamsString = filterParams.toString()

    const url = `${window.location.pathname}?section_id=${this.dataset.id}${searchParamsString ? `&${searchParamsString}` : ''}${filterParamsString ? `&${filterParamsString}` : ''}`
    this.renderSection(url)
  }

  updateRange(e) {
    this.maxValueWrapper = this.querySelector(
      '.filter-group__price-range-max span'
    )
    if (!this.maxValueWrapper) return
    this.maxValueWrapper.innerHTML = e.currentTarget.value
  }

  updateUncheckedInputs() {
    const activeInputsWrapper = this.querySelectorAll('.active-input')
    activeInputsWrapper.forEach((wrapper) => {
      const input = wrapper.querySelector('input')
      if (!input.checked) wrapper.classList.remove('active-input')
    })
  }

  renderSection(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .querySelector('search-results')

        const productsWrapper = this.querySelector(
          '[data-search-grid="products"]'
        )
        const newProductsWrapper = html.querySelector(
          '[data-search-grid="products"]'
        )

        const resultsWrapper = document.querySelector(
          '[data-results-count="all"] span'
        )
        const productsResultsWrapper = document.querySelector(
          '[data-results-count="products"]'
        )

        if (productsWrapper && newProductsWrapper) {
          productsWrapper.innerHTML = newProductsWrapper.innerHTML
        }

        if (resultsWrapper) {
          resultsWrapper.innerHTML =
            this.articlesCount + parseFloat(html.dataset.productsCount)
        }

        if (productsResultsWrapper) {
          productsResultsWrapper.innerHTML = html.dataset.productsCount
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }

  updateURL(searchParams) {
    window.history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
    )
  }
}

customElements.define('search-results', SearchResults)
